import {CHANGE_CREDENTIAL} from '../actions/actions';

const credsReducer = (state = {}, action) => {
    switch (action.type) {
        case CHANGE_CREDENTIAL:
            return Object.assign({}, state, action.creds);
        default:
            return state;
    }
};

export default credsReducer;


// WEBPACK FOOTER //
// ./src/app/reducers/credsReducer.js